/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BatchValidateDocumentsDto } from '../models/BatchValidateDocumentsDto';
import type { BatchValidateDocumentsResponse } from '../models/BatchValidateDocumentsResponse';
import type { DocumentResponse } from '../models/DocumentResponse';
import type { MessageResponse } from '../models/MessageResponse';
import type { UploadDocumentDto } from '../models/UploadDocumentDto';
import type { ValidateDocumentDto } from '../models/ValidateDocumentDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DocumentsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Upload a document
     * Upload a document attached to an entity. Any authenticated user can upload documents.
     * @returns DocumentResponse Document uploaded successfully.
     * @throws ApiError
     */
    public documentsControllerUpload({
        requestBody,
    }: {
        requestBody: UploadDocumentDto,
    }): CancelablePromise<DocumentResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/documents',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
            },
        });
    }
    /**
     * List all documents (Admin)
     * Returns a paginated list of documents with optional filters. Admin only.
     * @returns any List of documents.
     * @throws ApiError
     */
    public documentsControllerFindAll({
        page = 1,
        limit = 20,
        sortBy,
        sortOrder = 'desc',
        entityType,
        entityId,
        type,
        status,
    }: {
        /**
         * Page number
         */
        page?: number,
        /**
         * Items per page (max 200)
         */
        limit?: number,
        /**
         * Field to sort by
         */
        sortBy?: string,
        /**
         * Sort order (asc/desc)
         */
        sortOrder?: 'asc' | 'desc',
        /**
         * Filter by entity type
         */
        entityType?: 'society' | 'agent_profile' | 'user',
        /**
         * Filter by entity ID
         */
        entityId?: string,
        /**
         * Filter by document type
         */
        type?: 'KBIS' | 'COMPANY_AUTHORIZATION' | 'CNAPS' | 'ARTICLES_OF_ASSOCIATION' | 'REGISTRATION_PROOF' | 'IDENTITY_PROOF' | 'PRO_CARD' | 'ID_CARD' | 'PROOF_OF_ADDRESS' | 'RESIDENT_ID_CARD' | 'AUTHORIZATION_ATTESTATION',
        /**
         * Filter by verification status
         */
        status?: 'PENDING' | 'VALIDATED' | 'DENIED' | 'NOT_UPLOADED',
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/documents',
            query: {
                'page': page,
                'limit': limit,
                'sortBy': sortBy,
                'sortOrder': sortOrder,
                'entityType': entityType,
                'entityId': entityId,
                'type': type,
                'status': status,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Admin role required.`,
            },
        });
    }
    /**
     * Batch validate/reject documents (Admin)
     * Validates or rejects multiple documents in a single request. Requires ADMIN role. A reason is required for each denied document.
     * @returns BatchValidateDocumentsResponse Documents validated successfully.
     * @throws ApiError
     */
    public documentsControllerBatchValidate({
        requestBody,
    }: {
        requestBody: BatchValidateDocumentsDto,
    }): CancelablePromise<BatchValidateDocumentsResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/documents/batch-validate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error (missing reason for denial, invalid IDs).`,
                401: `Unauthorized.`,
                403: `Forbidden. Admin role required.`,
                404: `One or more documents not found.`,
            },
        });
    }
    /**
     * Get a fresh signed URL for a document (Admin)
     * Generates a fresh time-limited signed URL for a document stored in Firebase Storage. The signed URL expires after 60 minutes. Falls back to the stored URL if signed URL generation fails.
     * @returns any Signed URL returned.
     * @throws ApiError
     */
    public documentsControllerGetSignedUrl({
        id,
    }: {
        /**
         * Document unique identifier
         */
        id: string,
    }): CancelablePromise<{
        url?: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/documents/{id}/signed-url',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Admin role required.`,
                404: `Document not found.`,
            },
        });
    }
    /**
     * Stream document file content (Admin)
     * Proxies the document file from Firebase Storage through the API server with inline Content-Disposition. Used to avoid CORS issues when previewing PDFs in the admin dashboard.
     * @returns any File content streamed.
     * @throws ApiError
     */
    public documentsControllerGetFileContent({
        id,
    }: {
        /**
         * Document unique identifier
         */
        id: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/documents/{id}/content',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Admin role required.`,
                404: `Document not found.`,
            },
        });
    }
    /**
     * Get document by ID
     * Returns a single document by its unique identifier.
     * @returns DocumentResponse Document found.
     * @throws ApiError
     */
    public documentsControllerFindOne({
        id,
    }: {
        /**
         * Document unique identifier
         */
        id: string,
    }): CancelablePromise<DocumentResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/documents/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                404: `Document not found.`,
            },
        });
    }
    /**
     * Delete document
     * Delete a document. Only the entity owner or an admin can delete.
     * @returns MessageResponse Document deleted successfully.
     * @throws ApiError
     */
    public documentsControllerRemove({
        id,
    }: {
        /**
         * Document unique identifier
         */
        id: string,
    }): CancelablePromise<MessageResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/documents/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden.`,
                404: `Document not found.`,
            },
        });
    }
    /**
     * Validate or reject a document (Admin)
     * Admin endpoint to validate or deny a document. A description is required when denying.
     * @returns DocumentResponse Document validation updated.
     * @throws ApiError
     */
    public documentsControllerValidate({
        id,
        requestBody,
    }: {
        /**
         * Document unique identifier
         */
        id: string,
        requestBody: ValidateDocumentDto,
    }): CancelablePromise<DocumentResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/documents/{id}/validate',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Description required for denial.`,
                401: `Unauthorized.`,
                403: `Forbidden. Admin role required.`,
                404: `Document not found.`,
            },
        });
    }
}
